export const existingSystemBefore: Date = new Date(2024, 0, 1);
